// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see SavingsGoalManageGoalStateChangeEvent
 */
export var SavingsGoalManageGoalStateChange = function (_a) {
    var oldState = _a.oldState, newState = _a.newState;
    return ({
        name: "SavingsGoal Manage GoalStateChange",
        parameters: {
            cdf_entity: "SavingsGoal",
            cdf_action: "Manage",
            old_state: oldState !== undefined && oldState !== null ? oldState.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            new_state: newState !== undefined && newState !== null ? newState.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SavingsGoalSetStartEvent
 */
export var SavingsGoalSetStart = function (_a) {
    var flowToken = _a.flowToken, type = _a.type;
    return ({
        name: "SavingsGoal Set Start",
        parameters: {
            cdf_entity: "SavingsGoal",
            cdf_action: "Set",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SavingsGoalSetRemoveEvent
 */
export var SavingsGoalSetRemove = function (_a) {
    var flowToken = _a.flowToken, goalToken = _a.goalToken, isComplete = _a.isComplete;
    return ({
        name: "SavingsGoal Set Remove",
        parameters: {
            cdf_entity: "SavingsGoal",
            cdf_action: "Set",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            goal_token: goalToken !== undefined && goalToken !== null ? goalToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_complete: isComplete !== undefined && isComplete !== null ? isComplete.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SavingsGoalSetChooseAmountEvent
 */
export var SavingsGoalSetChooseAmount = function (_a) {
    var flowToken = _a.flowToken, amountCents = _a.amountCents, currencyCode = _a.currencyCode;
    return ({
        name: "SavingsGoal Set ChooseAmount",
        parameters: {
            cdf_entity: "SavingsGoal",
            cdf_action: "Set",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            amount_cents: amountCents !== undefined && amountCents !== null ? amountCents.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            currency_code: currencyCode !== undefined && currencyCode !== null ? currencyCode.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SavingsGoalSetChooseEmojiEvent
 */
export var SavingsGoalSetChooseEmoji = function (_a) {
    var flowToken = _a.flowToken, emoji = _a.emoji, isMultipleGoal = _a.isMultipleGoal;
    return ({
        name: "SavingsGoal Set ChooseEmoji",
        parameters: {
            cdf_entity: "SavingsGoal",
            cdf_action: "Set",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            emoji: emoji !== undefined && emoji !== null ? emoji.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_multiple_goal: isMultipleGoal !== undefined && isMultipleGoal !== null ? isMultipleGoal.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SavingsGoalSetSkipEmojiEvent
 */
export var SavingsGoalSetSkipEmoji = function (_a) {
    var flowToken = _a.flowToken;
    return ({
        name: "SavingsGoal Set SkipEmoji",
        parameters: {
            cdf_entity: "SavingsGoal",
            cdf_action: "Set",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SavingsGoalSetCompleteEvent
 */
export var SavingsGoalSetComplete = function (_a) {
    var flowToken = _a.flowToken, isMultipleGoal = _a.isMultipleGoal;
    return ({
        name: "SavingsGoal Set Complete",
        parameters: {
            cdf_entity: "SavingsGoal",
            cdf_action: "Set",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_multiple_goal: isMultipleGoal !== undefined && isMultipleGoal !== null ? isMultipleGoal.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SavingsGoalRemoveRemoveEvent
 */
export var SavingsGoalRemoveRemove = function (_a) {
    var goalToken = _a.goalToken;
    return ({
        name: "SavingsGoal Remove Remove",
        parameters: {
            cdf_entity: "SavingsGoal",
            cdf_action: "Remove",
            goal_token: goalToken !== undefined && goalToken !== null ? goalToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
